import React, { useContext, useEffect, useState } from "react"
import { AuthContext } from "../../../hooks/context/authContext";
import { usePostRequest } from "../../../hooks/usePostRequest/usePostRequest";
import { useGetRequest } from "../../../hooks/useGetRequest/useGetRequest";
import GenericModal from "../../../components/modal/GenericModal";
import { FILE_FORMATS, GENERIC_SUCCESS_TOAST_MESSAGE } from "../../../constants/hardCodedConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadFormatoResultadoEvaluacion2026API, guardarFormatoResultadoEvaluacion2026API } from "../../../consumers/backendApisUrls";
import { mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState } from "../../../consumers/httpRequiestsUtils";
import { toast } from "react-toastify";
import InputUploadFile from "../../../components/modalComponents/InputUploadFile";
import { downloadFile } from "../../../consumers/backendConsumer";

const FirmaResultadoEvaluacion2026Modal = ({ showModal, idEmpleado, idEmpleadoFlujoActividad, manageSearch }) => {

    const { state } = useContext(AuthContext);
    const [executePostRequest] = usePostRequest();
    const [executeGetRequest] = useGetRequest();
    const [validation, setValidation] = useState({});
    const [guardando, setGuardando] = useState(false);
    const [documentoFirmado, setDocumentoFirmado] = useState({});
    const [firmaColaborador, setFirmaColaborador] = useState({});
    const KEYS_INIT = { FirmaFileViewModel: "FirmaFileViewModel" };

    const SECTION_NAME = "modalFirmaResultadoEvaluacion2026Modal";

    const [subiendoArchivo, setSubiendoArchivo] = useState(false);
    const [s3UploadFileResponse, setS3UploadFileResponse] = useState({});

    const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    const init = async function () {

    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (guardando) return;
        if (!validaciones()) return;
        const docFirmado = await validarDocumentoFirmado();

        if (!docFirmado) {
            mostrarMensajeDeErrorConToast("No se pudo generar el documento firmado. Intente nuevamente.");
            return;
        }
        let payload = {
            IdEmpleado: idEmpleado,
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: docFirmado
        };
        setGuardando(true);
        const response = await executePostRequest(guardarFormatoResultadoEvaluacion2026API(), payload);
        if (responseCode200(response)) {
            showModal();
            toast.success((response?.data?.Message) ? response?.data?.Message : GENERIC_SUCCESS_TOAST_MESSAGE);
            setGuardando(false);
            await manageSearch();
        } else if (responseTieneModelState(response)) {
            setValidation(response?.response?.data.ModelState);
            setGuardando(false);
        } else {
            mostrarMensajeDeErrorConToast(response);
            setGuardando(false);
        }
    };

    const validaciones = () => {
        // 1. Validar que al menos haya subido la firma (el origen)
        if (isEmptyObject(firmaColaborador) || !firmaColaborador.OriginalFileName) {
            mostrarMensajeDeErrorConToast("Debe subir su firma antes de guardar.");
            return false;
        }

        return true;
    }
    const validarDocumentoFirmado = async () => {
        if (isEmptyObject(documentoFirmado)) {
            const dataBody = await obtenerFormatoFirmado();
            return dataBody;
        }
        else
            return documentoFirmado;
    }
    const btnDownloadFormatoAFirmar = async (event) => {
        event.preventDefault();
        const dataBody = await obtenerFormatoFirmado();
        if (dataBody)
            downloadFile(state.token, dataBody?.Path, dataBody?.OriginalFileName);

    };

    const obtenerFormatoFirmado = async () => {
        const updatedFirmaColaborador = {
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: firmaColaborador
        };
        const response = await executePostRequest(downloadFormatoResultadoEvaluacion2026API(), updatedFirmaColaborador);
        if (responseCode200(response)) {
            setDocumentoFirmado(response.data.Body);
            return response.data.Body;
        } else {
            mostrarMensajeDeErrorConToast(response);
            setDocumentoFirmado({});
            return null;
        }
    }

    return (
        <>
            <GenericModal showModal={showModal} width={"890px"} titulo="Firmar carta resultado Proceso Mentor/Experto 2026">
                <div className="margin-modal-body">
                    <div>
                        <form className="black-color-important">
                            <div className="row custom-form-group-modal">
                                <div>
                                    <InputUploadFile
                                        label="Firmar"
                                        direction="column"
                                        textButton="Subir Firma"
                                        name={KEYS_INIT.FirmaFileViewModel}
                                        uploadFile={firmaColaborador}
                                        setUploadFile={setFirmaColaborador}
                                        isUploading={subiendoArchivo}
                                        setIsUploading={setSubiendoArchivo}
                                        sectionName={SECTION_NAME}
                                        showToastSuccess={true}
                                        validExtensions={FILE_FORMATS.ALLOWED_IMAGE_FORMATS} />
                                </div>
                            </div>

                            <div className="row custom-form-group-modal">
                                <u>
                                    <a className="text-link-appereance" href="#" onClick={(event) => btnDownloadFormatoAFirmar(event)}><FontAwesomeIcon icon='download' /> Previsualizar carta de resultado</a>
                                </u>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="modal-footer" style={{ 'display': 'flex', 'justifyContent': 'space-between' }}>
                    <div className="message font-gothan-light" style={{ 'alignSelf': 'flex-start' }}>
                        <strong>
                            <p>* Campos obligatorios</p>
                            <p>* El formato permitido es un archivo .jpg o .png.</p>
                            <p>* Esta firma servirá para generar la carta de resultado firmada.</p>
                            <p>* Luego de subir su firma previsualizar el documento para poder guardar.</p>
                        </strong>
                    </div>
                    <div className="button" style={{ 'alignSelf': 'flex-end' }}>
                        <button className="btn btn-primary generic-button-ficha" onClick={onSubmit} disabled={subiendoArchivo || guardando}>Guardar</button>
                    </div>
                </div>
            </GenericModal>
        </>
    );
}

export default FirmaResultadoEvaluacion2026Modal;
